<template lang="pug">
  div.event-channel
    div.summary
      module-title(title="提要")
      div.summary-content {{summary}}
    div.channels
      channel-type(:getChannel="getChannel" ref="channelType")
      channel-list(:list="list" :changeSidx="changeSidx" :sidx="sidx" :loading="loading")
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
import ChannelType from './ChannelType'
import ChannelList from './ChannelList'
import client from '../server/server'
import moment from 'moment'
import _ from 'lodash'
import { toThousands } from '../config/config'
export default {
  name: 'EventChannel',
  data () {
    return {
      summary: '',
      sidx: 'indexInfluence',
      list: [],
      type: '',
      loading: false
    }
  },
  created () {
    this.getSummary()
  },
  methods: {
    getSummary () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventChannelSummary(params)
        .then(res => {
          if (res.success) {
            let data = res.data
            this.summary = `共有${toThousands(data.channelCount)}家渠道参与报道，有${toThousands(data.yjChannelCount)}家央级媒体参与；微博平台粉丝超千万用户参与数量${toThousands(data.qwFanCount)}，粉丝超百万用户参与数量${toThousands(data.bwFanCount)}。`
          }
        })
    },
    getChannel (type) {
      if (type) {
        this.type = type
      }
      let data = {
        id: this.$route.params.id
      }
      let params = {
        type: type || this.type,
        sidx: this.sidx
      }
      this.loading = true
      client.getEventChannel(data, params)
        .then(res => {
          if (res.success) {
            this.list = res.data.map(d => {
              let indexTag = [
                {
                  key: 'identity',
                  icon: require('@index/assets/img/event/identity.png'),
                  tag: `${d.majorType.replace(/,/g, ' ')}`
                },
                {
                  key: 'media',
                  icon: require('@index/assets/img/event/media.png'),
                  tag: `${d.administrativeLevel.replace(/,/g, ' ')}`
                },
                {
                  key: 'tag',
                  icon: require('@index/assets/img/event/tag.png'),
                  tag: `${d.identity.replace(/,/g, ' ')}`
                },
                {
                  key: 'fields',
                  icon: require('@index/assets/img/event/fields.png'),
                  tag: `${d.field.replace(/,/g, ' ')}${d.subdividedField ? ` | ${d.subdividedField.replace(/,/g, ' ')}` : ''}`
                },
                {
                  key: 'city',
                  icon: require('@index/assets/img/event/city.png'),
                  tag: d.area.replace(/ /g, '/')
                }
              ]
              let articles = d.articles.map(x => {
                return Object.assign({}, x, {
                  publishTime: moment(x.publishTime).format('YYYY/MM/DD HH:mm')
                })
              })
              return Object.assign({}, d, {
                indexTag: _.filter(indexTag, x => x.tag),
                articles: articles,
                headUrl: d.headUrl || require(`@index/assets/img/event/${this.$refs.channelType.type}.png`),
                expand: false,
                height: articles.length > 3 ? 68 : articles.length * 26 - 10
              })
            })
            this.loading = false
          }
        })
    },
    changeSidx (sidx) {
      if (sidx !== this.sidx) {
        this.sidx = sidx
        this.getChannel()
      }
    }
  },
  components: {
    ModuleTitle,
    ChannelType,
    ChannelList
  }
}
</script>

<style lang="scss" scoped>
  .event-channel{
    .summary{
      padding: 14px;
      background-color: #fff;
      border-radius: 4px;
      .summary-content{
        margin-top: 10px;
        color: #666;
      }
    }
    .channels{
      margin-top: 20px;
      height: 660px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 4px;
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventChannel/EventChannel.vue